module.exports = __webpack_public_path__ + "img/tulipng.3213cc06.png";